export function createTFSubmission() {
	let underwriter_id = $('#underwriter_id').val();
	if (underwriter_id > 0)  {
		let lead_id = $('.lead_update_popup').attr('data-current-lead-id');
		$('.submit_api_transfed').addClass('loading');
		$('.submit_api_transfed').html('Please wait...');

		$.ajax({
			url: '/leads/submit-api-transfed',
			type: "POST",
			dataType: "json",
			data: {
				'lead_id': lead_id,
			},
			cache: false,
			success: function (result) {

				if (result.code === 'SUCCESS') {
					// == Handle success exactly as before ==
					$('.submit_api_transfed').addClass('hidden');
					$('.submit_api_transfed').removeClass('loading');
					$('.submit_api_transfed').html('Submit to TRANSFED');

					$('<div class="confirmation-message">Sent successfully!</div>')
						.css({
							'position': 'relative',
							'color': 'green',
							'border': '1px solid green',
							'padding': '4px 10px',
							'margin-top': '10px',
							'background-color': '#e6ffe6',
							'border-radius': '4px',
						})
						.prependTo('.submit_api_wrap')
						.fadeOut(3000); // Fade out after 3 seconds

					location.reload();
					//getLeadData(lead_id);

				} else if (result.code === 'ALREADY_FOUND') {
					// == Ask if user wants to proceed ==
					if (confirm(result.message + '\n\nWould you like to proceed?')) {
						// Example: if you want to make another call
						// to proceed with an override:
						$.ajax({
							url: '/leads/submit-api-transfed',
							type: "POST",
							dataType: "json",
							data: {
								'lead_id': lead_id,
								'override': true // or something similar
							},
							success: function (res) {
								if (res.code === 'SUCCESS') {
									location.reload();
									//alert('Proceeding with submission...');
									//getLeadData(lead_id);
								//	$('.submit_api_transfed').addClass('hidden');

								} else {
									alert('Submission failed: ' + res.message);
								}
							}
						});
					} else {
						// User clicked "No," so reset button
						$('.submit_api_transfed').removeClass('loading');
						$('.submit_api_transfed').html('Submit to TRANSFED');
					}

				} else if (result.code === 'ERROR') {
					// == Handle other error ==
					alert('Error: ' + result.message);
					$('.submit_api_transfed').removeClass('loading');
					$('.submit_api_transfed').html('Submit to TRANSFED');
				}
			}
		});

	} else {
		alert('Please Select Underwriter first! Thanks.');
		return;
	}
}


export function initTFIDCheck(data) {
	// 1) Check if data object is present
	if (!data) {
		console.warn('initTFIDCheck called with null or undefined data.');
		return;
	}

	$('.submit_api_wrap .cn_wrpa').remove();
	$('.submit_api_transfed').removeClass('hidden');
	$('.submit_api_transfed').show();
	// 2) If we have a TF ID, hide button & show label
	if (data.tf_id) {
		//$('.submit_api_transfed').hide();

		let submittedText = '';
		if (data.last_ims_submitted_date) {
			submittedText = `Submitted to IMS on: ${data.last_ims_submitted_date}<br>`;
		}

		// Create the element
		$('.submit_api_wrap').append(`
      <span class="cn_wrpa">
        ${submittedText}
        TF #: <a target="_blank" href="https://www.transfed.pro/client/${data.tf_id}/1">${data.tf_id}</a>
      </span>
    `);
	}
}
